import _get from 'lodash.get';
import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
// import produce from 'immer';
import makeRequest from '../../utils/makeRequest';
import { ISeoData } from '../../utils/appInterface';
import { IParams } from './printASutils';

export interface IContentsDataItem {
  path?: string;
  tn?: string;
  sections: { [key: string]: any }[]
}
interface IReduxState {
  data: any;
  seo: ISeoData;
}

const reducerName = 'printeditionas';
const createActionName = (name: string) => `toi/${reducerName}/${name}`;

export const RECEIVE_ARTICLE_DATA = createActionName(
  'RECEIVE_ARTICLE_DATA',
);
export const DATA_LOADED = createActionName('DATA_LOADED');
export const DATA_LOADING = createActionName('DATA_LOADING');
export const ACTIVE_MSID = createActionName('ACTIVE_MSID');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');

function receiveArticleData(data: { [key: string]: any }) {
  return {
    type: RECEIVE_ARTICLE_DATA,
    payload: {
      data,
      msid: data.id,
    },
  };
}

function handleArticleDataError(error: Error) {
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}

function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

function fetchArticleData(params: IParams, isAppView: boolean, dispatch: (arg0: { type: string; payload?: { [key: string]: any }; error?: Error; }) => void) {
  dispatch(dataLoading());
  const appParameter = isAppView ? '&frmapp=yes' : '';
  const primeuser = params.frmprime === 'yes' ? '&isprime=true' : '';
  const url = `${getFeedUrl()}/toiprint/web/show/printnews?version=v2&path=/articleshow/${params.msid}.cms${primeuser}${appParameter}`;
  return makeRequest.get(url, { isMobile: params.isWapView });
}

export function loadArticleshowData(params: IParams) {
  return (dispatch: (arg0: { type: string; payload?: { [key: string]: any }; error?: Error; }) => void) =>
    new Promise(resolve => {
      fetchArticleData(params, params.isAppView, dispatch)
        .then((data: { [key: string]: any }) => {
          dispatch(dataLoaded());
          dispatch(receiveArticleData(data.data));
          resolve('1'); // To check & return data load status
        })
        .catch(error => {
          dispatch(dataLoaded());
          dispatch(handleArticleDataError(error));
          resolve('0');
        });
    });
}

export function updateActiveMsid(msid: string) {
  return {
    type: ACTIVE_MSID,
    payload: {
      activemsid: msid,
    },
  };
}
interface IAction {
  payload: { [key: string]: any };
  type: string;
}

export default function reducer(state: IReduxState = {} as IReduxState, action: IAction = {} as IAction) {
  switch (action.type) {
    case RECEIVE_ARTICLE_DATA: {
      const articleShowData = state.data ? { ...state.data } : {};
      articleShowData[action.payload.msid] = action.payload.data;
      return {
        ...state,
        data: articleShowData,
      };
    }
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case ACTIVE_MSID: {
      return {
        ...state,
        activemsid: action.payload.activemsid,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
